import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-left: 1px solid ", ";\n  padding-left: 24px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { color } from '@scp/ui-shared/theme/variables';
import styled from 'styled-components';
var FieldGroup = styled.div(_templateObject(), color.borderInput);
/**
 * Creates IndentedFieldGroup (clickable by preference) component
 * @example ./__docs__/IndentedFieldGroup.md
 */

export function IndentedFieldGroup(_ref) {
  var children = _ref.children;
  return React.createElement(FieldGroup, null, children);
}